import React, { useEffect, useState } from "react";
import NasInfo from "./nasinfo";
// import LeadLogo from "../assets/lead_logo.svg";
import { useLazyQuery, useMutation } from "@apollo/client";
import { useParams, useNavigate, Link } from "react-router-dom";
import "font-awesome/css/font-awesome.min.css";
import * as jose from "jose";
import {
  FIELD_VIST_QUERY,
  NAS_STATUS_QUERY,
  ACTIVITIES_DATA_QUERY,
  ACTIVITIES_DATA_CAST_QUERY,
  ACTIVITIES_DATA_SDCARD_QUERY,
  LATEST_OTP_QUERY,
  MOBILE_SEARCH_DATA_QUERY,
} from "../services/query";
import { Form, Button, ButtonGroup } from "react-bootstrap";
import InfoComponent from "./InfoComponent";
import UserService from "../utils/userService";
import {
  checkLastAction,
  checkMDMState,
  checkResources,
  checkVersion,
  checkNasStatus,
  bytesToGB,
  getNasPercentage,
  getDaysDifference,
  checkSDCardErrorState,
  checkSystemBuildVersionState,
  // getExpectedSystemBuildVersion,
} from "../utils/common";
import {
  SCHOOL_DATA_CONSTANTS,
  DEVICE_INFO_OBJ,
  OTP_DATA_INITAL_STATE,
  DRAWER_CONSTANTS,
  METABASE_IFRAME_HEIGHT,
  TIMELINE_CONSTANTS,
  PRODUCT_TYPE_CONFIG,
  // GOOD_SYSTEM_BUILD_VERSION,
} from "../constants/schoolData";
import { TABLE } from "../constants/table";
import Ellipsis from "../assets/ellipsis_icon.svg";
import TabQRComponent from "./TabQRComponent";
import TVEnrolmentComponent from "./TVEnrolmentComponent";
import { fetchTvEnrollment } from "../services/fetchApis";
import { setUpSchoolEnrollment } from "../services/fetchApis";
import { EVENT_NAMES_CONSTANT, logFirebaseEvent } from "../services/events";
import DrawerComponent from "./Drawer";
import SocialShareModal from "./SocialShareModal";
import { Dropdown, Table } from "antd";
import InfoTabs from "./InfoTabs";
import InfoCard from "./InfoCard";
import ActionsModal from "./ActionsModal";
import moment from "moment";
import { LOG_IN_TYPE } from "../constants/auth";
import ProgressComponent from "./ProgressComponent";

function SchoolData() {
  const navigate = useNavigate();
  const { schoolId: schoolIdParams } = useParams();
  const [schoolId, setSchoolId] = useState("");
  const [data, setData] = useState([]);
  const [metrics, setMetricsData] = useState([]);
  const [nasStatus, setNasData] = useState([]);
  const [nasPercent, setNasPercent] = useState([]);
  const [activites, setActivities] = useState([]);
  const [activitiesDropdown, setActivitiesDropdown] = useState("basic");
  const [selectedData, setSelectedData] = useState(null);
  const [countdown, setCountdown] = useState(30);
  const [actionitems, setActionItems] = useState([{ nasOffline: false }]);
  const [searchText, setSearchText] = useState("");
  const [loading, setLoading] = useState(false);
  const [groupId, setGroupId] = useState("");
  const [deviceInfo, setDeviceInfo] = useState(DEVICE_INFO_OBJ);
  const [otpData, setOtpData] = useState(OTP_DATA_INITAL_STATE);
  const [iframeData, setIframeData] = useState({
    data: null,
    height: 0,
  });
  const [shareModalState, setShareModalState] = useState({
    show: false,
    name: "",
    mobile: "",
    isTextCopied: false,
  });
  const [productType, setProductType] = useState(null);

  const [selectedCell, setSelectedCell] = useState(-1);
  const [drawerState, setDrawerState] = useState({
    isOpen: false,
    menuItemSelected: "",
  });

  const [timeLinePagination, setTimeLinePagination] = useState({
    page: TIMELINE_CONSTANTS.DEFAULT_PAGE_NO,
    limit: TIMELINE_CONSTANTS.DEFAULT_PAGE_LIMIT,
  });

  // states to handle actions modal
  const [selectedDevice, setSelectedDevice] = useState(null);
  const [showModal, setShowModal] = useState("");

  // to open only one expanded row at a time in antd table
  const [expandedRowKey, setExpandedRowKey] = useState([]);

  // contains table columns data
  const [tableColumns, setTableColumns] = useState([]);
  const [loadTableColumns, setLoadTableColumns] = useState(false);

  // to filter custom values from table
  const [filteredInfo, setFilteredInfo] = useState({});
  const [sortedInfo, setSortedInfo] = useState({});

  const handleChange = (pagination, filters, sorter) => {
    setFilteredInfo(filters);
    setSortedInfo(sorter);
  };

  const loginType = UserService.getLogInType();

  const selectCell = (cellId, label) => {
    setSelectedCell(cellId);
  };

  const [getDeviceVitals, { error }] = useLazyQuery(FIELD_VIST_QUERY);
  const [getMobileSearchData] = useLazyQuery(MOBILE_SEARCH_DATA_QUERY);
  const [getNasStatusData] = useLazyQuery(NAS_STATUS_QUERY);
  const [getActivitiesData, { loading: timelineLoading }] = useLazyQuery(ACTIVITIES_DATA_QUERY);
  const [getActivitiesCastData, { loading: castTimelineLoading }] = useLazyQuery(ACTIVITIES_DATA_CAST_QUERY);
  const [getActivitiesSdcardData, { loading: castsdcardTimelineLoading }] = useLazyQuery(ACTIVITIES_DATA_SDCARD_QUERY);


  const [getLatestOtp] = useMutation(LATEST_OTP_QUERY);
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const [activeTabs, setActiveTabs] = useState([]);

  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };

    window.addEventListener("resize", handleResize);

    // if user is already logged in, logout if user does not have version
    if (process.env.REACT_APP_VERSION !== "2.0.0") UserService.handleLogout();

    // Cleanup the event listener when component unmounts
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
    if (schoolIdParams) {
      setSchoolId(schoolIdParams);
      setSearchText(schoolIdParams);
      setLoadTableColumns(true);
    }
  }, [schoolIdParams]);

  useEffect(() => {
    if (data.length || selectedData) {
      fetchActivitiesData();
    }
  }, [data, selectedData, timeLinePagination.page, timeLinePagination.limit]);

  const clearFilters = () => {
    setFilteredInfo({});
    setSortedInfo({});
  };

  useEffect(() => {
    // Fetch data from the backend

    if (schoolId) {
      setLoading(true);
      clearFilters();
      fetchData();
      setSelectedCell(-1);
      setTimeLinePagination({
        page: 1,
        limit: 10,
      });
      setProductType(null);
      if (schoolId.length !== 10) {
        fetchNasData();
        setGroupId("");
        setDeviceInfo(DEVICE_INFO_OBJ);

        navigate(`/schoolData/${schoolId}`, {
          replace: true,
        });
      } else {
        navigate(`/teacherData/${schoolId}`, {
          replace: true,
        });
      }
    }
  }, [schoolId]);

  useEffect(() => {
    if (loadTableColumns) {
      setTableColumns(getColumns());
      setLoadTableColumns(false);
    }
  }, [data]);

  useEffect(() => {
    setTableColumns(getColumns());
  }, [filteredInfo, sortedInfo]);

  useEffect(() => {
    const { menuItemSelected, isOpen } = drawerState;
    if (
      menuItemSelected === DRAWER_CONSTANTS.badFirmwareMenuItem ||
      menuItemSelected === DRAWER_CONSTANTS.oneClickMenuItem
    ) {
      getMetabaseIframe(menuItemSelected);
      if (isOpen) handleSetDrawerState(DRAWER_CONSTANTS.drawerState);
    }
  }, [drawerState]);

  const isOneClickRequired = (item) => {
    const lastOnclickDay = getDaysDifference(item.oneClickRunAt, new Date());

    if (item?.oneClickRunAt === null || lastOnclickDay >= 7) {
      return true;
    } else {
      return false;
    }
  };

  const checkData = (data = [], mdmDevices = []) => {
    let tabData = [];
    let tvData = [];
    let greenTabs = 0;
    let resourceOkay = 0;
    let appOkay = 0;
    let mdmTabOkay = 0;
    let tabStatus = "grey";
    let sdCardOkay = 0;
    let firmwareOkay = 0;
    let distinctTPSDevices = [];
    let distinctDevices = [];
    let totalDeviceIds = 0;

    let tvStatus = "amber";
    let tvMDMOkay = 0;

    // let updatePending = 0;
    data.forEach((item) => {
      const appVersionStatus = checkVersion(item);
      const resourceStatus = checkResources(item);
      const oneClickStatus = checkLastAction(item);
      const nasStatus = checkNasStatus(item);
      const mdmstate = checkMDMState(item);
      const sdCardErrorState = checkSDCardErrorState(item);
      const systemBuildVersionStatus = checkSystemBuildVersionState(item);

      const overallstatus =
        appVersionStatus +
        resourceStatus +
        oneClickStatus +
        nasStatus +
        (1 - parseInt(item.developerOptionEnabled || 0) * 1) +
        (2 - parseInt(item.canManageExternalStorage || 0) * 2);

      const appstatus =
        appVersionStatus +
        (1 - parseInt(item.canManageExternalStorage || 0) * 1);

      if (overallstatus < 2) {
        greenTabs++;
      }
      if (resourceStatus === 0) {
        resourceOkay++;
      }
      if (appstatus === 0) {
        appOkay++;
      }

      // if (mdmstate === 0) {
      //   mdmTabOkay++;
      // }

      if (item?.deviceId?.length !== 0) {
        totalDeviceIds++;
        if (!distinctDevices?.includes(item?.deviceId))
          distinctDevices.push(item?.deviceId);
      }

      if (item.__typename === "tabVitalsRecords") {
        if (item?.mdmDeviceId !== null && item?.mdmDeviceId.trim() !== "") {
          if (!distinctTPSDevices?.includes(item?.mdmDeviceId))
            distinctTPSDevices.push(item?.mdmDeviceId);
          mdmTabOkay++;
        }

        if (sdCardErrorState === 0) {
          sdCardOkay++;
        }

        if (systemBuildVersionStatus === 0) {
          firmwareOkay++;
        }

        if (item?.contextAppNamespace && !productType) {
          const product = PRODUCT_TYPE_CONFIG.find(pt => (
            item?.contextAppNamespace).includes(pt?.productName));
          setProductType(product);
        }

        tabData.push({
          ...item,
          appVersionStatus,
          resourceStatus,
          oneClickStatus,
          nasStatus,
          mdmstate,
          overallstatus,
          appstatus,
          sdAvailableSpacePercentage:
            (bytesToGB(item?.availableExternalStorage) /
              bytesToGB(item?.totalExternalStorage)) *
            100,
          isOneClickRequired: isOneClickRequired(item),
          sdCardCorrupted: sdCardErrorState,
          systemBuildVersionStatus,
          type: SCHOOL_DATA_CONSTANTS.device.tab,
        });
      } else if (item?.groupId) {
        tvMDMOkay++;
      }

      if (item.__typename === "tvVitalsRecords") {
        tvData.push({
          ...item,
          appVersionStatus,
          resourceStatus,
          oneClickStatus,
          nasStatus,
          mdmstate,
          overallstatus,
          appstatus,
          sdCardCorrupted: sdCardErrorState,
          systemBuildVersionStatus,
          type: SCHOOL_DATA_CONSTANTS.device.tv,
        });
      }
    });
    const tpsTitle = ` (${distinctTPSDevices?.length}/${mdmTabOkay})`;
    const deviceTitle = ` (${distinctDevices?.length}/${totalDeviceIds})`;

    if (tabData.length) {
      const resourceOkayPerc = (resourceOkay / tabData.length) * 100;
      const appOkayPerc = (appOkay / tabData.length) * 100;

      if (resourceOkayPerc > 80 && appOkayPerc > 80) {
        tabStatus = "super-green";
      } else if (resourceOkayPerc > 80) {
        tabStatus = "green";
      } else if (resourceOkayPerc > 60) {
        tabStatus = "amber";
      } else {
        tabStatus = "red";
      }
    }

    return {
      data: tabData,
      metrics: {
        greenTabs,
        appOkay,
        resourceOkay,
        tabStatus,
        mdmTabOkay,
        tvStatus,
        tvMDMOkay,
        sdCardOkay,
        firmwareOkay,
        tpsTitle,
        deviceTitle,
      },
    };
  };

  const sortData = (data) => {
    if (data.length) {
      if (selectedCell === 11) {
        return data?.sort((a, b) => b.overallstatus - a.overallstatus);
      } else if (selectedCell === 12) {
        return data?.sort((a, b) => b.appstatus - a.appstatus);
      } else if (selectedCell === 13) {
        return data?.sort((a, b) => b.mdmstate - a.mdmstate);
      } else if (selectedCell === 14) {
        return data?.sort((a, b) => a.sdCardCorrupted - b.sdCardCorrupted);
      } else if (selectedCell === 15) {
        return data?.sort(
          (a, b) => a.systemBuildVersionStatus - b.systemBuildVersionStatus
        );
      } else {
        return data?.sort((a, b) => b.overallstatus - a.overallstatus);
      }
    }
  };

  const updateCountdown = (countdown) => {
    if (countdown === 0 && schoolId) {
      fetchData(true);
    }
  };

  async function fetchData(isAutoRefresh) {
    try {
      let response;
      if (schoolId?.length < 10) {
        response = await getDeviceVitals({
          variables: {
            schoolId: parseInt(schoolId, 10),
          },
          fetchPolicy: SCHOOL_DATA_CONSTANTS.networkOnly,
        });
      } else {
        response = await getMobileSearchData({
          variables: {
            mobile: schoolId,
          },
          fetchPolicy: SCHOOL_DATA_CONSTANTS.networkOnly,
        });
      }
      const { data } = response;

      const tabVitalsRecord = data?.getDeviceVitals?.tabVitals?.records || [];
      const tvVitalsRecord = data?.getDeviceVitals?.tvVitals?.records || [];
      let result = [...tabVitalsRecord, ...tvVitalsRecord];

      if (!result.length) {
        logFirebaseEvent(EVENT_NAMES_CONSTANT.failed_to_load, {
          is_school_search: true,
          school_id: parseInt(schoolId, 10),
        });
      }
      result = checkData(result);
      setData(result.data);
      if (!isAutoRefresh) {
        setActiveTabs([result.data[0]]);
        setExpandedRowKey(["data-1"]);
        setSelectedData(result.data[0])
        setMetricsData(result.metrics);
      }

      setLoading(false);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  }

  async function fetchNasData() {
    const { data } = await getNasStatusData({
      variables: {
        schoolId: parseInt(schoolId, 10),
      },
    });
    setNasData(data?.getNasStatus);

    if (
      data?.getNasStatus &&
      data?.getNasStatus?.status !== SCHOOL_DATA_CONSTANTS.online
    ) {
      setActionItems({ nasOffline: true });
    } else {
      setActionItems(null);
    }

    setNasPercent(getNasPercentage(data?.getNasStatus));
  }
  const handleActivitiesDropdownChange = async (value) => {

    setActivitiesDropdown(value)
    let payload = {
      mobile: selectedData?.teacherMobile || String(data[0].teacherMobile),
      deviceId: selectedData?.mdmDeviceId || selectedData?.deviceId,
      page: timeLinePagination.page,
      limit: timeLinePagination.limit,
    }
    if (value == 'without_casting') {
      payload.is_casting = '0'
      const activityData = await getActivitiesCastData({
        variables: payload,
      });
      setActivities(activityData.data.getActivitiesCast);
    }
    else if (value == 'with_casting') {
      payload.is_casting = '1'
      const activityData = await getActivitiesCastData({
        variables: payload,
      });
      setActivities(activityData.data.getActivitiesCast);
    }
    else if (value == 'sd_card_view') {
      const activityData = await getActivitiesSdcardData({
        variables: payload,
      });
      setActivities(activityData.data.getActivitiesSdcard);
    }
    else {
      const activityData = await getActivitiesData({
        variables: payload,
      });
      setActivities(activityData.data.getActivities);
    }


  }
  const fetchActivitiesData = async () => {
    // Print the fallback value (data[0].teacherMobile) if selectedData?.teacherMobile is undefined or null   // let activityData=null;
    if (selectedData?.contextAppNamespace === 'com.lbpl.propel.teach' || selectedData?.contextAppNamespace === 'com.lbpl.propel.teach.stag') {
      //in case of propel send mdm deviceid or adv id
      const activityData = await getActivitiesData({
        variables: {
          mobile: selectedData?.teacherMobile || String(data[0].teacherMobile),
          deviceId: selectedData?.mdmDeviceId || selectedData?.deviceId,
          page: timeLinePagination.page,
          limit: timeLinePagination.limit,
        },
      });
      setActivities(activityData.data.getActivities);
    } else {
      handleActivitiesDropdownChange(activitiesDropdown)
    }
  };

  const updateSchoolId = (value) => {
    if (!value) {
      setSchoolId("");
      return;
    }
    if (value.length > 0) setSchoolId(value);
    setLoadTableColumns(true);
  };

  const handleSubmit = () => {
    const regExp = /^\d+$/;
    const isValidSchoolId = regExp.test(searchText);
    const isMobileNo = searchText.length === 10;
    let properties = {};
    if (isValidSchoolId) {
      updateSchoolId(searchText);
      if (isMobileNo) {
        properties = {
          mobile_number: searchText,
          is_school_search: false,
          number_type: "teacher",
        };
      } else {
        properties = {
          is_school_search: true,
          school_id: searchText,
        };
      }
      logFirebaseEvent(EVENT_NAMES_CONSTANT.search_button_clicked, properties);
    }
    setCountdown(30);
  };

  const handleKeyPress = (target) => {
    if (target.charCode === 13) {
      handleSubmit();
    }
  };

  const getGroupId = () => {
    let groupId = 0;
    if (data.length) {
      for (let i = 0; i < data.length; i++) {
        if (data[i].groupId) return `1,${data[i].groupId}`;
      }
    }
    return groupId;
  };

  const showUserInfo = () => {
    const user = UserService.getUserData();
    return (
      <div className="user-details-container">
        <div className="search-container">
          <Form.Control
            onChange={(e) => setSearchText(e.target.value)}
            className="search-input"
            id="inlineFormInput"
            placeholder="Enter school id or mobile number"
            type={searchText}
            value={searchText}
            onKeyPress={handleKeyPress}
          />
          <div className="search-button">
            <Button onClick={handleSubmit}>
              {SCHOOL_DATA_CONSTANTS.btns.search}
            </Button>
          </div>
        </div>
        {windowWidth > 1000 ? (
          <div className="user-info-container">
            <div>
              <div>
                Welcome, <strong>{`${user.name}`}</strong>
              </div>
              <div className="role-badge">{user.rolename}</div>
            </div>
            <Button className="logout-btn" onClick={handleLogOut}>
              {SCHOOL_DATA_CONSTANTS.btns.logout}
            </Button>
          </div>
        ) : (
          ""
        )}
      </div>
    );
  };

  const errMessageText = () => {
    if (loading) return "Loading...";
    if (error?.networkError && error?.networkError?.result) {
      return (
        error?.networkError?.result?.error ||
        SCHOOL_DATA_CONSTANTS.messages.wentWrong
      );
    }
    if (!!schoolId && !data.length && !loading) {
      return error?.message || SCHOOL_DATA_CONSTANTS.messages.notAvailable;
    }
    return SCHOOL_DATA_CONSTANTS.messages.default;
  };

  const handleSetupSchoolEnrolment = async () => {
    try {
      const data = await setUpSchoolEnrollment(schoolId);
      if (data?.status === "OK") {
        setGroupId(`1,${data?.group}`);
      }
    } catch (error) {
      console.log(`[Error: Failed to enroll tv]`);
    }
  };

  const getDeviceComponent = () => {
    if (selectedCell === 3) {
      return (
        <div className="flex-row">
          <div className="cell">
            <TVEnrolmentComponent
              deviceId={deviceInfo.id}
              isBtnDisabled={!deviceInfo.id || !!deviceInfo.validationMsg}
              setDeviceInfo={setDeviceInfo}
              onClickEnroll={handleEnrolmentBtnClick}
              message={deviceInfo.msg}
              enrollmentStatus={deviceInfo.status}
              validationError={deviceInfo.validationMsg}
              handleTVBtnClickEvent={handleTVBtnClickEvent}
              handleTVEnrolEvent={handleTVEnrolEvent}
            />
          </div>
        </div>
      );
    }
    if (selectedCell === 13 && !groupId) {
      return (
        <div className="tv-enrollment-container">
          <ButtonGroup size="sm">
            <Button variant="light" onClick={handleSetupSchoolEnrolment}>
              <i className="fa fa-tablet rotate-90" aria-hidden="true"></i>
              <span className="ml-2">Setup school for TAB enrolment</span>
            </Button>
          </ButtonGroup>
        </div>
      );
    }

    if (selectedCell === 13 && groupId) {
      return (
        <div className="flex-row">
          <div className="cell">
            <TabQRComponent
              config="1"
              group={groupId}
              handleLogQREvent={handleLogQREvent}
            />
          </div>
        </div>
      );
    }

    return <></>;
  };

  const handleEnrolmentBtnClick = async () => {
    try {
      const data = await fetchTvEnrollment(schoolId, deviceInfo.id, "TV");
      if (data?.deviceId) {
        setDeviceInfo({
          ...deviceInfo,
          status: data.status,
          msg: SCHOOL_DATA_CONSTANTS.messages.enrollSuccess,
        });
        handleTVEnrolEvent(EVENT_NAMES_CONSTANT.enrolment_status_changed, true);
      } else if (data?.msg) {
        setDeviceInfo({
          ...deviceInfo,
          msg:
            data?.msg || SCHOOL_DATA_CONSTANTS.tvEnrollmentErrors.enrollFailed,
          status: data.status,
        });
        handleTVEnrolEvent(
          EVENT_NAMES_CONSTANT.enrolment_status_changed,
          false,
          data?.msg || SCHOOL_DATA_CONSTANTS.tvEnrollmentErrors.enrollFailed
        );
      }
    } catch (error) {
      console.log(`[Error: Failed to enroll tv]`);
    }
  };

  const handleGetTeachersOtp = async (mobile, cardStatus, lastUpdated) => {
    try {
      const { data: result } = await getLatestOtp({
        variables: {
          input: {
            mobile: mobile || "",
          },
        },
      });
      setOtpData({ ...otpData, data: result.getLatestOtp });

      // firebase event tracking
      logFirebaseEvent(EVENT_NAMES_CONSTANT.get_otp_clicked, {
        card_login_id: mobile,
        card_status: cardStatus,
        last_updated: lastUpdated,
        otp_value: result.getLatestOtp.otpCode,
        otp_expiry_time: result.getLatestOtp.expiredTime,
        otp_attempts_let: result.getLatestOtp.attempts,
      });
    } catch (err) {
      if (err?.networkError && err?.networkError.result) {
        setOtpData({
          ...OTP_DATA_INITAL_STATE,
          error: err?.networkError.result?.msg,
        });
      } else {
        setOtpData({
          ...OTP_DATA_INITAL_STATE,
          error: "Unable to fetch data",
        });
      }
      console.log("Error in fetching latest OTP", err.message);
    }
  };

  const resetOtpData = () => {
    setOtpData(OTP_DATA_INITAL_STATE);
  };

  const handleLogOut = () => {
    //firebase log events
    logFirebaseEvent(EVENT_NAMES_CONSTANT.logout_clicked, {
      user_role: UserService.getLogInType()?.rolename || "",
      login_type: UserService.getLogInType(),
    });

    UserService.handleLogout();
  };

  // const onClickSubHeaderFilter = (id, type) => {
  //   selectCell(id, type);

  //   //firebase log events
  //   let event = "";
  //   let satisfactoryDevices = 0;
  //   let isTv = false;
  //   let total_devices = data.length;

  //   if (type === "TABS.TPSOkay") {
  //     event = EVENT_NAMES_CONSTANT.tps_okay_clicked;
  //     satisfactoryDevices = metrics.mdmTabOkay;
  //     isTv = false;
  //   } else if (type === "TABS.AppOkay") {
  //     event = EVENT_NAMES_CONSTANT.app_okay_clicked;
  //     satisfactoryDevices = metrics.appOkay;
  //   } else if (type === "TVs") {
  //     event = EVENT_NAMES_CONSTANT.tps_okay_clicked;
  //     satisfactoryDevices = metrics.tvMDMOkay;
  //     total_devices = metrics.tvMDMOkay;
  //     isTv = true;
  //   } else if (type === "NAS") {
  //     event = EVENT_NAMES_CONSTANT.nas_resources_clicked;
  //     satisfactoryDevices = nasPercent;
  //     total_devices = nasStatus ? 1 : 0;
  //   } else {
  //     event = EVENT_NAMES_CONSTANT.resource_okay_clicked;
  //     satisfactoryDevices = metrics.resourceOkay;
  //   }

  //   logFirebaseEvent(event, {
  //     school_id: schoolId,
  //     satisfactory_devices: satisfactoryDevices,
  //     total_devices: total_devices,
  //     is_tv: isTv,
  //   });
  // };

  const handleLogQREvent = (configId, group) => {
    logFirebaseEvent(EVENT_NAMES_CONSTANT.qr_clicked, {
      school_id: parseInt(schoolId, 10),
      configuration: configId === "1" ? "M7" : "M8",
      tab_config: configId,
      group_id: group,
      total_devices: data.length,
      satisfactory_devices: metrics.mdmTabOkay,
    });
  };

  const handleTVBtnClickEvent = () => {
    logFirebaseEvent(EVENT_NAMES_CONSTANT.tv_enrolment_clicked, {
      school_id: parseInt(schoolId, 10),
      total_devices: metrics.tvMDMOkay,
      satisfactory_devices: metrics.tvMDMOkay,
    });
  };

  const handleTVEnrolEvent = (eventName, success = false, error = "") => {
    let properties = {};
    if (eventName === EVENT_NAMES_CONSTANT.enrolment_submitted) {
      properties = {
        enrolment_triggered_from: deviceInfo.triggerFrom,
        device_id_modified: deviceInfo.isFieldChanged,
      };
    } else {
      properties = {
        enrolment_triggered_from: deviceInfo.triggerFrom,
        success: success,
      };

      if (error) {
        properties = {
          ...properties,
          error,
        };
      }
    }

    logFirebaseEvent(eventName, {
      school_id: parseInt(schoolId, 10),
      total_devices: metrics.tvMDMOkay,
      satisfactory_devices: metrics.tvMDMOkay,
      deviceId: deviceInfo.id,
      ...properties,
    });
  };

  const resourceDownloadingMultipleTimes = () => {
    console.log("activities is", activites)
    if (activites?.length > 0) {
      const oneMonthAgo = new Date();
      oneMonthAgo.setMonth(oneMonthAgo.getMonth() - 1);

      let mapper = {};
      let previousDetail = null;

      for (let i = 0; i < activites.length; i++) {
        const currentActivity = activites[i];
        const activityTimestamp = new Date(currentActivity.received);

        if (activityTimestamp < oneMonthAgo) {
          break;
        }

        if (
          currentActivity.event === "resource download" &&
          currentActivity.details !== "" &&
          !currentActivity.details.endsWith(", 0 downloaded")
        ) {
          if (
            previousDetail &&
            previousDetail.details === currentActivity.details
          ) {
            if (!mapper[currentActivity.details]) {
              mapper[currentActivity.details] = 1;
            } else {
              mapper[currentActivity.details]++;
            }
          }
          previousDetail = currentActivity;
        }
      }

      const keys = Object.keys(mapper);
      if (!keys.length) return false;
      for (let i = 0; i < keys.length; i++) {
        if (mapper[keys[i]] > 1) {
          return true;
        }
      }

      return false;
    } else {
      return false;
    }
  };

  const getMetabaseIframe = async () => {
    setIframeData({
      data: null,
      height: 0,
    });
    const { menuItemSelected } = drawerState;
    let payload = null;
    let iframeUrl = "";
    let iframeHeight = METABASE_IFRAME_HEIGHT.default;
    if (menuItemSelected === DRAWER_CONSTANTS.oneClickMenuItem) {
      payload = {
        resource: { question: 1163 },
        params: {
          //date: moment(Date.now()).format("YYYY-MM-DD"),
          //school: schoolId,
        },
        exp: Math.round(Date.now() / 1000) + 10 * 60, // 10 minute expiration
      };
    } else if (menuItemSelected === DRAWER_CONSTANTS.badFirmwareMenuItem) {
      payload = {
        resource: { dashboard: 204 },
        params: {},
        exp: Math.round(Date.now() / 1000) + 10 * 60, // 10 minute expiration
      };
    }

    const secret = new TextEncoder().encode(process.env.REACT_APP_METABASE_KEY);
    const alg = "HS256";

    var token = await new jose.SignJWT(payload)
      .setProtectedHeader({ alg })
      .sign(secret);

    if (menuItemSelected === DRAWER_CONSTANTS.oneClickMenuItem) {
      iframeUrl =
        process.env.REACT_APP_METABASE_URL +
        "/embed/question/" +
        token +
        "#bordered=true&titled=true";
      iframeHeight = METABASE_IFRAME_HEIGHT.large;
    } else if (menuItemSelected === DRAWER_CONSTANTS.badFirmwareMenuItem) {
      iframeUrl =
        process.env.REACT_APP_METABASE_URL +
        "/embed/dashboard/" +
        token +
        "#bordered=true&titled=true";
      iframeHeight = METABASE_IFRAME_HEIGHT.large;
    }

    setIframeData({
      data: iframeUrl,
      height: iframeHeight,
    });
  };

  const handleSetDrawerState = (type, value = "") => {
    if (type === DRAWER_CONSTANTS.drawerState) {
      setDrawerState((prev) => ({
        isOpen: !prev.isOpen,
        menuItemSelected: "",
      }));
      return;
    }

    setDrawerState({ ...drawerState, menuItemSelected: value });
  };

  const removeIframeContainer = () => {
    setIframeData({
      data: null,
      height: 0,
    });
  };

  const handleShareModalState = (mobileNumber = "", name = "") => {
    setShareModalState((prev) => ({
      ...prev,
      show: !prev.show,
      name,
      mobile: mobileNumber,
      isTextCopied: false,
    }));
  };

  const handleCopyLink = (url = "") => {
    setShareModalState((prev) => ({ ...prev, isTextCopied: true }));
    window.navigator.clipboard.writeText(url);
  };

  function getCardStatusClass(data) {
    if (data?.overallstatus > 4) {
      return "bg-card-danger";
    } else if (data?.overallstatus > 1) {
      return "bg-card-warning";
    }
    return "bg-card-okay";
  }

  const getCardStatusValue = (dataObj) => {
    let cardStatus = "";
    const cardStatusClass = getCardStatusClass(dataObj);

    if (cardStatusClass === "bg-card-danger") {
      cardStatus = "Red";
    } else if (cardStatusClass === "bg-card-warning") {
      cardStatus = "Amber";
    } else {
      cardStatus = "Green";
    }
    return cardStatus;
  };

  const handleDeviceClick = (device, event, modalType) => {
    event.stopPropagation();

    setSelectedDevice(device);

    if (modalType === "otpAction")
      handleGetTeachersOtp(
        device.teacherMobile,
        getCardStatusValue(device),
        moment(device.timestamp).format("DD-MM-YYYY hh:MM A")
      );
    setShowModal(modalType);
  };

  // const handleTableSearchFilter = (selectedKeys, confirm, dataIndex) => {
  //   confirm();
  //   setTableFiltersearch({
  //     column: dataIndex,
  //     value: selectedKeys[0],
  //   });
  // };

  // const getColumnSearchProps = (dataIndex) => ({
  //   filterDropdown: ({
  //     setSelectedKeys,
  //     selectedKeys,
  //     confirm,
  //     clearFilters,
  //     close,
  //   }) => (
  //     <div style={{ padding: 8 }} onKeyDown={(e) => e.stopPropagation()}>
  //       <Input
  //         ref={searchInput}
  //         placeholder={`Search ${dataIndex}`}
  //         value={selectedKeys[0]}
  //         onChange={(e) =>
  //           setSelectedKeys(e.target.value ? [e.target.value] : [])
  //         }
  //         onPressEnter={() =>
  //           handleTableSearchFilter(selectedKeys, confirm, dataIndex)
  //         }
  //         style={{ marginBottom: 8, display: "block" }}
  //       />
  //       <Button
  //         type="primary"
  //         onClick={() =>
  //           handleTableSearchFilter(selectedKeys, confirm, dataIndex)
  //         }
  //         size="small"
  //         style={{ marginRight: 20 }}
  //       >
  //         Search
  //       </Button>
  //       <Button
  //         onClick={() => {
  //           clearFilters();
  //           setTableFiltersearch({
  //             column: "",
  //             value: "",
  //           });
  //           close();
  //         }}
  //         size="small"
  //       >
  //         Reset
  //       </Button>
  //     </div>
  //   ),
  //   filterIcon: (filtered) => "abc",
  //   onFilter: (value, record) =>
  //     record[dataIndex]
  //       ?.toString()
  //       ?.toLowerCase()
  //       ?.includes(value?.toLowerCase()),
  //   onFilterDropdownOpenChange: (visible) => {
  //     if (visible) {
  //       setTimeout(() => searchInput.current?.select(), 100);
  //     }
  //   },
  // });

  const getDropdownItemList = (data) => {
    const items = [
      {
        key: "1",
        label: (
          <div className="card-share-btn">
            <span
              role="presentation"
              onClick={(event) => {
                event.preventDefault();
                event.stopPropagation();
                handleDeviceClick(data, event, "action");
              }}
              className="font-weight-bold dflex dflex-space-between"
            >
              <span>
                <i className="fa fa-solid fa-check"></i>
              </span>
              <span>Actions</span>
            </span>
          </div>
        ),
      },
      {
        key: "2",
        label: (
          <div className="card-share-btn">
            <span
              role="presentation"
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                handleShareModalState(data.teacherMobile, data.name);
              }}
              className="font-weight-bold dflex"
            >
              <span>
                <i className="fa fa-share"></i>
              </span>
              <span>Share</span>
            </span>
          </div>
        ),
      },
    ];

    if (loginType.toLocaleLowerCase() !== LOG_IN_TYPE.nucleus)
      items.push({
        key: "3",
        label: (
          <div className={"card-share-btn"}>
            <span
              role="presentation"
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();

                handleDeviceClick(data, e, "otpAction");
              }}
              className="font-weight-bold dflex dflex-space-between"
            >
              <span>
                <i className="fa fa-solid fa-mobile"></i>
              </span>
              <span>Get OTP</span>
            </span>
          </div>
        ),
      });

    return items;
  };

  // config for table columns
  const getColumns = () =>
    TABLE.map((item) => {
      item.filteredValue = filteredInfo[item.key] || null;
      item.sortOrder =
        sortedInfo.columnKey === item.key ? sortedInfo.order : null;

      switch (item.key) {
        case "share": {
          if (schoolId.length === 10) {
            item.title = (
              <div className="link-container">
                <Link
                  to={`/schoolData/${data[0]?.schoolId}`}
                  className="redirect-to-school-link"
                >
                  <div className="d-flex">
                    <i className="fa fa-home"></i>
                  </div>
                </Link>
              </div>
            );
          } else item.title = "";

          return {
            ...item,
            render: (_, data) => (
              <Dropdown
                menu={{
                  items: getDropdownItemList(data),
                }}
                trigger={["click"]}
              >
                <img src={Ellipsis} alt="ellipsis-icon" />
              </Dropdown>
            ),
          };
        }
        case "stat": {
          let config = {};
          if (windowWidth > 1000) {
            config = {
              fixed: "left",
              width: 10,
            };
          }
          return {
            ...item,
            ...config,
            onCell: (record) => {
              const cardStatusClass = getCardStatusClass(record);
              let cardStatus = "";
              if (cardStatusClass === "bg-card-danger") {
                cardStatus = "red";
              } else if (cardStatusClass === "bg-card-warning") {
                cardStatus = "#FFBF00";
              } else {
                cardStatus = "green";
              }
              return {
                style: { backgroundColor: cardStatus },
              };
            },
          };
        }
        case "teacherMobile": {
          let config = {};
          if (windowWidth > 1000) {
            config = {
              fixed: "left",
              width: 120,
            };
          }
          item.filters = [
            {
              text: "Green",
              value: "0",
            },
            {
              text: "Warning",
              value: "1",
            },
            {
              text: "Danger",
              value: "2",
            },
          ];
          item.onFilter = (value, record) => {
            switch (value) {
              case "2":
                return record?.overallstatus > 4;
              case "1":
                return record?.overallstatus > 1;
              default:
                return record?.overallstatus <= 1;
            }
          };
          return {
            ...item,
            ...config,
          };
        }
        case "role": {
          let config = {};
          if (windowWidth > 1000) {
            config = {
              fixed: "left",
              width: 150,
            };
          }
          const roles = new Set(data.map((item) => item.role));
          const uniqueRoles = Array.from(roles).map((value, index) => ({
            text: value,
            value: value,
          }));

          item.filters = uniqueRoles;
          item.onFilter = (value, record) => {
            return record?.role == value;
          };
          return {
            ...item,
            ...config,
          };
        }
        case "name": {
          let config = {};
          if (windowWidth > 1000) {
            config = {
              fixed: "left",
              width: 150,
            };
          }
          return {
            ...item,
            ...config,
          };
        }
        case "mdmDeviceId": {
          item.title = `TPS Device ID ` + metrics?.tpsTitle;
          const tpsDevices = new Set(data.map((item) => item.mdmDeviceId));
          const uniqueTPSDevices = Array.from(tpsDevices).map(
            (value, index) => ({
              text: value,
              value: index,
            })
          );

          item.filters = uniqueTPSDevices;
          item.onFilter = (value, record) => {
            return record?.mdmDeviceId == item.filters[value].text;
          };
          return { ...item };
        }
        case "deviceId": {
          item.title = `Device ID ` + metrics?.deviceTitle;
          const uuidDevices = new Set(data.map((item) => item.deviceId));
          const uniqueDevices = Array.from(uuidDevices).map((value, index) => ({
            text: value,
            value: index,
          }));

          item.filters = uniqueDevices;
          item.onFilter = (value, record) => {
            return record?.deviceId == item.filters[value].text;
          };
          return {
            ...item,
          };
        }
        case "Firmware Status": {
          item.title = `Device ID (${metrics?.firmwareOkay}/${data?.length})`;
          return {
            ...item,
          };
        }
        case "resourceStatus": {
          item.title = `Resource Download (${metrics?.resourceOkay}/${data?.length})`;
          return {
            ...item,
          };
        }
        case "sdCardErrorMessage": {
          item.title = `SD Card OK (${metrics?.sdCardOkay}/${data?.length})`;
          return {
            ...item,
          };
        }
        case "isTechBookEnabled": {
          item.title = "Tech Book Enabled";
          // Sorting based on Yes/No
          item.sorter = (a, b) => a?.isTechBookEnabled?.localeCompare(b?.isTechBookEnabled);
          // Filters for Yes/No values
          item.filters = [
            {
              text: "Yes",
              value: "Yes",
            },
            {
              text: "No",
              value: "No",
            },
          ];
          // Apply filter logic
          item.onFilter = (value, record) => record?.isTechBookEnabled === value;
          return {
            ...item,
          };
        }
        case "tabModel": {
          const tabModels = new Set(data.map((item) => item.tabModel));
          // Convert the Set back to an array
          const uniqueTabModels = Array.from(tabModels).map((value, index) => ({
            text: value,
            value: index,
          }));

          item.filters = uniqueTabModels;
          item.onFilter = (value, record) => {
            return record?.tabModel == item.filters[value].text;
          };
          return {
            ...item,
          };
        }
        case "tabDelivereyDate": {
          const tabDelivereyDate = new Set(data.map((item) => item.tabDelivereyDate));
          // Convert the Set back to an array
          const uniquetabDelivereyDate = Array.from(tabDelivereyDate).map((value, index) => ({
            text: value,
            value: index,
          }));

          item.filters = uniquetabDelivereyDate;
          item.onFilter = (value, record) => {
            return record?.tabDelivereyDate == item.filters[value].text;
          };
          return {
            ...item,
          };
        }
        case "inWarranty": {
          const inWarranty = new Set(data.map((item) => item.inWarranty));
          // Convert the Set back to an array
          const uniqueinWarranty = Array.from(inWarranty).map((value, index) => ({
            text: value,
            value: index,
          }));

          item.filters = uniqueinWarranty;
          item.onFilter = (value, record) => {
            return record?.inWarranty == item.filters[value].text;
          };
          return {
            ...item,
          };
        }
        case "redResources": {
          item.filters = [
            {
              text: "< 50",
              value: "0",
            },
            {
              text: "50 - 500",
              value: "1",
            },
            {
              text: "500 - 1000",
              value: "2",
            },
            {
              text: "1000 - 5000",
              value: "3",
            },
            {
              text: "> 5000",
              value: "4",
            },
          ];

          item.onFilter = (value, record) => {
            switch (value) {
              case "0":
                return record?.redResources < 50;
              case "1":
                return (
                  (record?.redResources >= 50) & (record?.redResources < 500)
                );
              case "2":
                return (
                  (record?.redResources >= 500) & (record?.redResources < 1000)
                );
              case "3":
                return (
                  (record?.redResources >= 1000) & (record?.redResources < 5000)
                );
              default:
                return record?.redResources >= 5000;
            }
          };
          return {
            ...item,
          };
        }
        case "teacherRedResources": {
          item.filters = [
            {
              text: "< 50",
              value: "0",
            },
            {
              text: "50 - 500",
              value: "1",
            },
            {
              text: "500 - 1000",
              value: "2",
            },
            {
              text: "1000 - 5000",
              value: "3",
            },
            {
              text: "> 5000",
              value: "4",
            },
          ];

          item.onFilter = (value, record) => {
            switch (value) {
              case "0":
                return record?.teacherRedResources < 50;
              case "1":
                return (
                  (record?.teacherRedResources >= 50) &
                  (record?.teacherRedResources < 500)
                );
              case "2":
                return (
                  (record?.teacherRedResources >= 500) &
                  (record?.teacherRedResources < 1000)
                );
              case "3":
                return (
                  (record?.teacherRedResources >= 1000) &
                  (record?.teacherRedResources < 5000)
                );
              default:
                return record?.teacherRedResources >= 5000;
            }
          };

          return {
            ...item,
          };
        }
        case "appVersion": {
          const appVersions = new Set(data.map((item) => item.appVersion));
          // Convert the Set back to an array
          const appVersionSet = Array.from(appVersions).map((value, index) => ({
            text: value?.toString(),
            value: index,
          }));

          item.filters = appVersionSet;
          item.onFilter = (value, record) => {
            return record?.appVersion == item.filters[value].text;
          };
          return {
            ...item,
          };
        }
        case "lastTimestamp": {
          item.filters = [
            {
              text: "Last 24hr",
              value: "0",
            },
            {
              text: "24hr - 72hr",
              value: "1",
            },
            {
              text: "3d - 7d",
              value: "2",
            },
            {
              text: "7d - 30d",
              value: "3",
            },
            {
              text: "Over 30days",
              value: "4",
            },
          ];
          item.onFilter = (value, record) => {
            switch (value) {
              case "0":
                return (
                  moment.utc(record?.lastTimestamp).local() >=
                  moment().subtract(1, "days").local().valueOf()
                );
              case "1":
                return (
                  moment.utc(record?.lastTimestamp).local() <
                  moment().subtract(1, "days").local().valueOf() &&
                  moment.utc(record?.lastTimestamp).local() >=
                  moment().subtract(3, "days").local().valueOf()
                );

              case "2":
                return (
                  moment.utc(record?.lastTimestamp).local() <
                  moment().subtract(3, "days").local().valueOf() &&
                  moment.utc(record?.lastTimestamp).local() >=
                  moment().subtract(7, "days").local().valueOf()
                );
              case "3":
                return (
                  moment.utc(record?.lastTimestamp).local() <
                  moment().subtract(7, "days").local().valueOf() &&
                  moment.utc(record?.lastTimestamp).local() >=
                  moment().subtract(30, "days").local().valueOf()
                );

              default:
                return (
                  moment.utc(record?.lastTimestamp).local() <=
                  moment().subtract(30, "days").local().valueOf()
                );
            }
          };
          return {
            ...item,
          };
        }
        default:
          return item;
      }
    });

  const onClickSubHeaderFilter = (id, type) => {
    selectCell(id, type);

    //firebase log events
    let event = "";
    let satisfactoryDevices = 0;
    let isTv = false;
    let total_devices = data.length;

    if (type === "TABS.TPSOkay") {
      event = EVENT_NAMES_CONSTANT.tps_okay_clicked;
      satisfactoryDevices = metrics.mdmTabOkay;
      isTv = false;
    } else if (type === "TABS.AppOkay") {
      event = EVENT_NAMES_CONSTANT.app_okay_clicked;
      satisfactoryDevices = metrics.appOkay;
    } else if (type === "TVs") {
      event = EVENT_NAMES_CONSTANT.tps_okay_clicked;
      satisfactoryDevices = metrics.tvMDMOkay;
      total_devices = metrics.tvMDMOkay;
      isTv = true;
    } else if (type === "NAS") {
      event = EVENT_NAMES_CONSTANT.nas_resources_clicked;
      satisfactoryDevices = nasPercent;
      total_devices = nasStatus ? 1 : 0;
    } else {
      event = EVENT_NAMES_CONSTANT.resource_okay_clicked;
      satisfactoryDevices = metrics.resourceOkay;
    }

    logFirebaseEvent(event, {
      school_id: schoolId,
      satisfactory_devices: satisfactoryDevices,
      total_devices: total_devices,
      is_tv: isTv,
    });
  };

  const getOverAllStatus = (data) => {
    if (data) {
      return (
        checkVersion(data) +
        checkResources(data) +
        checkLastAction(data) +
        checkNasStatus(data) +
        (1 - parseInt(data?.developerOptionEnabled || 0) * 1) +
        (2 - parseInt(data?.canManageExternalStorage || 0) * 2)
      );
    }

    return 0;
  };

  const handleToggleModal = () => {
    setShowModal("");
    resetOtpData();
  };

  const fixedHeight = { y: "" };

  const handleCheckboxAction = (column) => {
    let columns = [...tableColumns];
    columns = columns.map((col) => {
      if (col.dataIndex === column.dataIndex) {
        return {
          ...col,
          ...column,
        };
      }
      return col;
    });

    setTableColumns(columns);
  };

  const handleCardClick = (cardData) => {
    setActiveTabs((prevActiveTabs) =>
      prevActiveTabs?.includes(cardData) ? prevActiveTabs : [cardData]
    );
  };

  const selectedColumns = () => tableColumns.filter((item) => item?.isSelected);

  const handleTimelinePagination = (page, limit) => {
    setTimeLinePagination(prev => ({
      page: limit === prev.limit ? page : TIMELINE_CONSTANTS.DEFAULT_PAGE_NO,
      limit,
    }));
  }

  return (
    <div>
      <>
        <div className="top-header-inner-container py-3">
          <i
            className="fa fa-bars mr-3"
            style={{ color: "black", fontSize: "22px" }}
            role="presentation"
            onClick={() => handleSetDrawerState(DRAWER_CONSTANTS.drawerState)}
          ></i>
          <img className="lead-logo" src={productType?.logo || PRODUCT_TYPE_CONFIG[0].logo} alt="lead-logo"></img>
          {showUserInfo()}
        </div>
      </>

      <div style={{ paddingTop: "83px" }}>
        <DrawerComponent
          onClose={() => handleSetDrawerState(DRAWER_CONSTANTS.drawerState)}
          isOpen={drawerState.isOpen}
          onClickMenuItem={handleSetDrawerState}
          handleLogOut={handleLogOut}
          isMobileDevice={windowWidth < 1000}
          menuItemDisabled={false}
          tableColumns={tableColumns}
          handleCheckboxAction={handleCheckboxAction}
        />

        {!!data.length && (
          <ProgressComponent
            initialCount={countdown}
            updateCountdown={updateCountdown}
          />
        )}
        {!!Object.keys(metrics).length > 0 && (
          <div className="main-kpi-container">
            <div
              className={`flex-row kpi-container ${selectedCell !== -1 ? "selected" : ""
                }`}
            >
              <div className="cell flex-col">
                <div className={`status-label ${metrics.tabStatus}`}>
                  <i className="fa fa-tablet"></i>
                  {`${data.length > 1
                    ? SCHOOL_DATA_CONSTANTS.statusLabels.tabs
                    : SCHOOL_DATA_CONSTANTS.statusLabels.tab
                    } (${data.length})`}
                </div>
                <div className="flex-row">
                  <div
                    className="cell remove-pointer"
                  // className={`cell ${selectedCell === 11 ? "selected" : ""}`}
                  // onClick={() =>
                  //   onClickSubHeaderFilter(11, "TABS.ResourceOkay")
                  // }
                  >
                    <div className="kpi-value">
                      {metrics.resourceOkay}/
                      <div className="kpi-sub-value">{data.length}</div>
                    </div>
                    <div className="kpi-label">
                      {SCHOOL_DATA_CONSTANTS.statusLabels.resource}
                    </div>
                    <div className="arrow">&nbsp;</div>
                  </div>
                  <div
                    className="cell remove-pointer"
                  // className={`cell ${selectedCell === 12 ? "selected" : ""}`}
                  // onClick={() => onClickSubHeaderFilter(12, "TABS.AppOkay")}
                  >
                    <div className="kpi-value">
                      {metrics.appOkay}/
                      <div className="kpi-sub-value">{data.length}</div>
                    </div>
                    <div className="kpi-label">
                      {SCHOOL_DATA_CONSTANTS.statusLabels.app}
                    </div>
                    <div className="arrow">&nbsp;</div>
                  </div>
                  <div
                    className={`cell ${selectedCell === 13 ? "selected" : ""}`}
                    onClick={() => {
                      onClickSubHeaderFilter(13, "TABS.TPSOkay");
                      if (!groupId) setGroupId(getGroupId());
                    }}
                  >
                    <div className="kpi-value">
                      {metrics.mdmTabOkay}/
                      <div className="kpi-sub-value">{data.length}</div>
                    </div>
                    <div className="kpi-label">
                      {SCHOOL_DATA_CONSTANTS.statusLabels.mdm}
                    </div>
                    <div className="arrow">&nbsp;</div>
                  </div>
                  <div
                    className="cell remove-pointer"
                  // className={`cell ${selectedCell === 14 ? "selected" : ""}`}
                  // onClick={() =>
                  //   onClickSubHeaderFilter(14, "TABS.SdCardOkay")
                  // }
                  >
                    <div className="kpi-value">
                      {metrics.sdCardOkay}/
                      <div className="kpi-sub-value">{data.length}</div>
                    </div>
                    <div className="kpi-label">
                      {SCHOOL_DATA_CONSTANTS.statusLabels.sdCard}
                    </div>
                    <div className="arrow">&nbsp;</div>
                  </div>
                  <div
                    className="cell remove-pointer"
                  // className={`cell ${selectedCell === 15 ? "selected" : ""}`}
                  // onClick={() =>
                  //   onClickSubHeaderFilter(15, "TABS.SystemOkay")
                  // }
                  >
                    <div className="kpi-value">
                      {metrics.firmwareOkay}/
                      <div className="kpi-sub-value">{data.length}</div>
                    </div>
                    <div className="kpi-label">
                      {SCHOOL_DATA_CONSTANTS.statusLabels.firmware}
                    </div>
                    <div className="arrow">&nbsp;</div>
                  </div>
                </div>
              </div>
              <div
                className="cell flex-col remove-pointer"
              // className={`cell flex-col ${
              //   selectedCell === 2 ? "selected" : ""
              // }`}
              >
                <NasInfo nasStatus={nasStatus} nasPercent={nasPercent} />
              </div>
              <div
                className={`cell flex-col ${selectedCell === 3 ? "selected" : ""
                  }`}
                onClick={() => onClickSubHeaderFilter(3, "TVs")}
              >
                <div className={`status-label ${metrics.tvStatus}`}>
                  <i className="fa fa-television"></i>
                  {SCHOOL_DATA_CONSTANTS.statusLabels.tvs} ({metrics.tvMDMOkay})
                </div>
                <div className="flex-row">
                  <div className="cell">
                    <div className="kpi-value">{metrics.tvMDMOkay}</div>
                    <div className="kpi-label">
                      {SCHOOL_DATA_CONSTANTS.statusLabels.mdm}
                    </div>
                  </div>
                </div>
                <div className="arrow">&nbsp;</div>
              </div>
              <div
                className={`cell flex-col`}
              >
                <div className={`status-label ${metrics.tvStatus}`}>
                  <div style={{ height: '19px' }}></div>
                </div>
                <div className="flex-row">
                  <div className="cell" >
                    <div className="kpi-value">{productType?.label || PRODUCT_TYPE_CONFIG[0].label}</div>
                    <div className="kpi-label">
                      {SCHOOL_DATA_CONSTANTS.statusLabels.productType}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
        <div className="action-footnote">
          {SCHOOL_DATA_CONSTANTS.messages.wait}
        </div>
        {getDeviceComponent()}
        {!!iframeData.data && (
          <div className="user-details-container iframe-container">
            <div>
              <i
                className="fa fa-close close-icon"
                role="presentation"
                onClick={removeIframeContainer}
              ></i>
            </div>
            <iframe
              title="reports"
              src={iframeData.data}
              width={windowWidth}
              height={iframeData.height}
              allowtransparency="true"
              className="metabase-iframe"
            ></iframe>
          </div>
        )}
        {!!data.length &&
          (windowWidth > 1000 ? (
            <Table
              className="visit-data-table"
              expandable={{
                expandedRowKeys: expandedRowKey,
                expandedRowRender: (record) => (
                  <InfoTabs
                    data={record}
                    updateActivitiesDropDown={(value) => handleActivitiesDropdownChange(value)}
                    activites={activites}
                    setSelectedData={setSelectedData}
                    handleGetTeachersOtp={handleGetTeachersOtp}
                    otpData={otpData.data}
                    resetOtpData={resetOtpData}
                    otpDataError={otpData.error}
                    nasPercent={nasPercent}
                    isResourceDownloadingMultipleTimes={resourceDownloadingMultipleTimes()}
                    windowWidth={windowWidth}
                    nasStatus={nasStatus}
                    onShareUrl={handleShareModalState}
                    pagination={timeLinePagination}
                    onChangePagination={handleTimelinePagination}
                    timelineLoading={timelineLoading || castTimelineLoading || castsdcardTimelineLoading}
                  />
                ),
                onExpand: (isOpen, record) => {
                  const expandRow = [];
                  console.log("is open", isOpen, record)
                  if (isOpen) {
                    expandRow.push(record?.key);
                    setSelectedData(record);
                    setTimeLinePagination(
                      {
                        page: TIMELINE_CONSTANTS.DEFAULT_PAGE_NO,
                        limit: TIMELINE_CONSTANTS.DEFAULT_PAGE_LIMIT
                      }
                    )
                  }
                  setExpandedRowKey(expandRow);
                },
                showExpandColumn: true,
              }}
              pagination={false}
              columns={selectedColumns()}
              dataSource={sortData(data).map((item, index) => ({
                ...item,
                key: `data-${index + 1}`,
              }))}
              onChange={handleChange}
              scroll={{ x: selectedColumns().length * 156, ...fixedHeight }}
            />
          ) : (
            data?.map((device, index) => {
              (
                <InfoCard
                  updateActivitiesDropDown={(value) => handleActivitiesDropdownChange(value)}
                  key={`device-${index + 1}`}
                  data={device}
                  activities={activites}
                  className="school-data-card-container"
                  showHeader
                  overAllStatus={getOverAllStatus(device)}
                  handleDeviceClick={handleDeviceClick}
                  handleGetTeachersOtp={handleGetTeachersOtp}
                  otpData={otpData.data}
                  nasPercent={nasPercent}
                  isResourceDownloadingMultipleTimes={resourceDownloadingMultipleTimes()}
                  windowWidth={windowWidth}
                  nasStatus={nasStatus}
                  activeTabs={activeTabs}
                  setActiveTabs={() => handleCardClick(device)}
                  onShareUrl={handleShareModalState}
                  pagination={timeLinePagination}
                  onChangePagination={handleTimelinePagination}
                  timelineLoading={timelineLoading || castTimelineLoading || castsdcardTimelineLoading}
                  setSelectedData={setSelectedData}
                />
              )
            }
            )
          ))}
        {(!data.length || loading) && (
          <InfoComponent message={errMessageText()} />
        )}
        <SocialShareModal
          url={`${window.location.origin}/#/teacherData/${shareModalState.mobile}`}
          showModal={shareModalState.show}
          onCloseModal={handleShareModalState}
          onCopyLink={handleCopyLink}
          isTextCopied={shareModalState.isTextCopied}
          schoolId={schoolId}
          teacherName={shareModalState.name}
          teacherMobileNumber={shareModalState.mobile}
        />
        <ActionsModal
          showModal={showModal}
          handleToggleModal={handleToggleModal}
          selectedDevice={selectedDevice}
          otpDataError={otpData.error}
          otpData={otpData.data}
        />
      </div>
    </div>
  );
}

export default SchoolData;